<div
  class="alert-container"
  role="alert"
  [class]="[`${options().type}-alert`, alertService.isAlertOpen() ? 'open' : '']">
  <p class="alert-message" aria-label="alert message">{{ options().message | translate }}</p>
  <button *ngIf="options().actionLabel" (click)="clickAction()" mat-button>
    {{ options().actionLabel || '' | translate }}
  </button>
  <button
    *ngIf="!options().hideClose"
    mat-button
    (click)="alertService.closeAlert()"
    mat-icon-button
    aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</div>
